import React from 'react';

const EmotionalContent = () => {
  return (
    <div className="prose prose-gray max-w-none">
      <p className="text-gray-600 leading-relaxed">
        We take special care with emotional and mental health-related content:
      </p>
      <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-600">
        <li>Enhanced encryption for sensitive emotional data</li>
        <li>Strict access controls for mental health information</li>
        <li>Regular staff training on emotional data sensitivity</li>
      </ul>
    </div>
  );
};

export default EmotionalContent;